import * as React from 'react';
import { headingSectionIntroFirstContext } from './context';
export function useHeadingSectionIntroFirst() {
    var headingSectionIntroFirst = React.useContext(headingSectionIntroFirstContext);
    return headingSectionIntroFirst;
}
